export default __webpack_public_path__ + "static/media/doctor-dog.7d737f63.png";